import { render, staticRenderFns } from "./ExamSection.vue?vue&type=template&id=33bf9588&scoped=true"
import script from "./ExamSection.vue?vue&type=script&lang=js"
export * from "./ExamSection.vue?vue&type=script&lang=js"
import style0 from "./ExamSection.vue?vue&type=style&index=0&id=33bf9588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf9588",
  null
  
)

export default component.exports